export const faqData = [
  {
    question: "Desconheço as pesquisas e os interesses do corpo docente do meu curso.",
    answer:
      "É sua responsabilidade buscar informações sobre os interesses do corpo docente do curso. Uma forma de fazer isso é acessando os sites dos docentes e verificando suas publicações científicas mais recentes.",
  },
  {
    question: "Como posso descobrir o site de quem leciona?",
    answer:
      "Nem todo docente possui um site. No entanto, a página da UFSC lista o corpo docente de cada câmpus e, quando disponível, inclui links para seus sites. Além disso, parte dos docentes divulga o site na assinatura de e-mails, em materiais didáticos ou nas turmas do Moodle.",
  },
  {
    question: "Não encontrei o site, mas achei publicações no Google Acadêmico e no Lattes.",
    answer:
      "Ótimo! Leia as publicações mais recentes para entender melhor esses interesses de pesquisa.",
  },
  {
    question: "Não encontrei o site nem publicações no Google Acadêmico ou Lattes. O que faço?",
    answer:
      "Envie um e-mail cordial perguntando se há disponibilidade para orientar TCCs e quais são os interesses de pesquisa.",
  },
  {
    question: "Eu não sei como ler um artigo científico.",
    answer: (
      <>
        A leitura de artigos científicos é bem diferente da leitura de outros tipos de texto. <a target="_blank" rel="noopener noreferrer" href="https://web.archive.org/web/20241223211348/https://web.stanford.edu/class/ee384m/Handouts/HowtoReadPaper.pdf">Este guia de duas páginas</a> pode ajudar você a aprender a ler artigos científicos.
      </>
    ),
  },
  {
    question: "Eu tenho dificuldade em ler artigos escritos em inglês.",
    answer: (
      <>
        Grande parte da literatura avançada em computação está em inglês. Se isso ainda é um obstáculo para você, talvez seja melhor aprimorar seu inglês antes de começar o TCC. Há muitos recursos gratuitos disponíveis online para ajudar você, como este: <a target="_blank" rel="noopener noreferrer" href="https://letmegooglethat.com/?q=como+aprender+a+ler+em+ingl%C3%AAs+de+gra%C3%A7a">Aprender inglês gratuitamente</a>.
      </>
    ),
  },
  {
    question: "Li o artigo, mas não entendi quase nada. O que faço?",
    answer: 
      "Leia novamente com atenção e procure entender os termos desconhecidos no Google ou em ferramentas como o ChatGPT. Artigos científicos frequentemente abordam áreas muito específicas e avançadas. Seu curso deve ter lhe dado uma base suficiente para entender, ao menos, a área do artigo e o problema que ele tenta resolver. Conseguir interpretar artigos científicos é essencial para conduzir um TCC.",
  },
  {
    question: "Entendi o artigo, mas não tem relação com os meus interesses.",
    answer: (
      <>
        Isso é perfeitamente normal. É provável que a preferência seja orientar estudantes com interesses alinhados aos da própria pesquisa. Lembre-se: <strong>você precisa de orientação, não o contrário</strong>. Da mesma forma que você não deve trabalhar em algo que não lhe interessa, ninguém é obrigado a orientar temas fora dos próprios interesses.
      </>
    ),
  },
  {
    question: "Gosto muito de um docente. Será que aceitaria me orientar mesmo sem interesses alinhados?",
    answer:
      "Isso depende de cada docente. Entre em contato de forma educada e resumida, explicando sua situação e sugerindo próximos passos. Nesta página, você encontrará exemplos de como escrever esse e-mail.",
  },
  {
    question: "Gostei muito do artigo de um docente. Tem tudo a ver com o que quero fazer no meu TCC.",
    answer: (
      <>
        Ótimo! <a href="/students/ufsc#etapa-2a">Clique aqui</a> para ver como enviar um e-mail adequado a quem escreveu o artigo.
      </>
    ),
  },
  {
    question: "Gostei do artigo de um docente, mas ainda não sei o que quero fazer no meu TCC.",
    answer: (
      <>
        Sem problemas! <a href="/students/ufsc#etapa-2b">Clique aqui</a> para aprender como entrar em contato.
      </>
    ),
  },
];
